import "./WorkflowComponent.scss";
import template from "./WorkflowComponent.html";
import { IComponentOptions, IOnDestroy } from "angular";
import { Observable, ReplaySubject } from "rxjs";
import { IsoDate } from "../../../pseudo-types/DateTypes";
import { DateTimeUtil } from "../../../js/util/DateTimeUtil";
import moment from "moment";
import { WorkflowRecord, WorkflowRecords } from "./models/WorkflowRecord";
import { WorkflowService } from "./service/WorkflowService";
import { WorkflowTaskService } from "./wizard/WorkflowTaskService";
import { ArrayUtil } from "../../../js/util/ArrayUtil";
import { descendingUsing } from "../../../js/util/UtilFunctions";
import { AccountId } from "../../types/AccountRecord";
import { WorkflowViewStore } from "./store/WorkflowViewStore";
import { WorkflowViewModel, WorkflowViewModels } from "./models/WorkflowViewModel";

export const Workflow = "tfWorkflow";

export function workflow(): IComponentOptions {
  return {
    template,
    bindings: {
      accountId: "<"
    },
    controllerAs: "ctrl",
    controller: WorkflowComponentController
  };
}

export class WorkflowComponentController implements IOnDestroy {

  /** @input */
  public set accountId(accountId: AccountId | null) {
    if (accountId != null) {
      this.accountId$.next(accountId);
      this.store.updateAccountId(accountId);
    }
  }

  private readonly accountId$ = new ReplaySubject<AccountId>(1);
  private readonly destroy$ = new ReplaySubject<boolean>(1);
  private readonly store: WorkflowViewStore;
  public readonly models$: Observable<WorkflowViewModels>;

  /** @ngInject */
  public constructor(private readonly workflowService: WorkflowService,
    private readonly workflowTaskService: WorkflowTaskService) {
    this.store = new WorkflowViewStore(workflowService);
    this.models$ = this.store
      .notes
      .map((records) => records.map((r) => WorkflowViewModel.of(r)));
  }

  public async createTask() {
    this.accountId$.subscribe(resp => {
      var modalResult = this.workflowTaskService.openEdit(this.store, resp);
    });
    
  }

  public async updateTask(workflowRecord: WorkflowRecord) {
    this.accountId$.subscribe(resp => {
      this.workflowTaskService.openEdit(this.store, resp, workflowRecord);
    });
  }

  public $onDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
